export default "__VITE_ASSET__2XeT_Ei1__"